<template>
  <v-container fluid>
    <v-dialog v-model="dialogLoader" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <material-card icon="mdi-clipboard-text" inline title="Download Reports">
      <v-card-actions>
          <v-btn v-if="$vuetify.breakpoint.smAndUp" @click="reloadPage" elevation="1" style="margin-right:120px" absolute right top> <v-icon left>mdi-refresh</v-icon>Refresh</v-btn>
          <v-btn v-else fixed  fab small color="grey lighten-1" @click="reloadPage" elevation="1" class="mr-n2 mt-6" style="opacity:.6;"> <v-icon>mdi-refresh</v-icon></v-btn>
      </v-card-actions>
      <v-card-actions>
        <router-link slot="right" :to="{ name: 'B2SReportDashboard' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="2" class="mr-n2 mt-2" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <v-card-text class="pt-0 pr-1">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }"
        :items-per-page="10"
        :headers="headers"
        :items="items"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn @click="download(item.s3URL)" v-if="item.status === 'Completed'" class="px-2 ml-1 white--text ma-1" color="primary" min-width="0" small>
            <v-icon small> mdi-download</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
// import CONSTANTS from '@/utils/constants'
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import _sortBy from 'lodash/sortBy'
import moment from 'moment'
export default {
  components: { MaterialCard },
  name: 'B2SReportDownload',
  data () {
    return {
      dialogLoader: false,
      items: [],

      search: '',
      headers: [
        { text: 'Report Name', sortable: true, value: 'name' },
        { text: 'Applied Filter', value: 'params', sortable: false },
        { text: 'Status', sortable: true, value: 'status' },
        { text: 'created At', value: 'createdAt', sortable: false },
        { text: 'updatedAt', value: 'updatedAt', sortable: false },
        { text: 'Download', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },
  async created () {
    await this.getReportList()
  },
  methods: {
    getReportList: async function () {
      try {
        this.dialogLoader = true
        const response = await http.get(`${constants.API_URL}/api/report/getreport`)
        this.items = response.data
        this.items.forEach(el => {
          el.createdAt = moment(el.createdAt).format('DD-MM-YYYY')
          el.updatedAt = moment(el.updatedAt).format('DD-MM-YYYY')
        })
        console.log('data--', this.items)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.dialogLoader = false
      }
    },
    download: async function (key) {
      try {
        this.dialogLoader = true
        let url = await http.get(`${constants.API_URL}/api/ticket/downloadurl?s3urlKey=${key}`)

        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.dialogLoader = false
      }
    },
    async reloadPage () {
      await this.getReportList()
    }
  }
}
</script>
